import { createApp } from "vue";
import App from "./App.vue";

// Default theme
import "@splidejs/vue-splide/css";
import { Splide, SplideSlide } from "@splidejs/vue-splide";

import router from "./router";
import store from "./store";
import "./scss/main.scss";

const app = createApp(App);
app.use(store).use(router).mount("#app");

app.component("VueCarousel", Splide);
app.component("VueSlide", SplideSlide);
